import Menu from 'UI/Application/Components/Menus/user/Menu';

export default function UserRoute() {
  return (
    <Menu/>
  );
}
